import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import { Container, Stack, Typography } from '@mui/material';
// components
import { CellList } from '../sections/@dashboard/cell';
// mock
import { useParams } from 'react-router-dom';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import CellModal from 'src/components/modal/CellModal';
import Loader from 'src/components/loader/loader';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
// ----------------------------------------------------------------------

export default function Cell() {
    const [visible, setVisible] = useState(false);
    const [visibleLock, setVisibleLock] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const getRef = useRef(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const params = useParams();
    const isEdit = useRef(false);
    const [data, setData] = useState({});
    const delFlags = useRef(false);
    const lockRefFlags = useRef(false);
    const [lockFlags, setLockFlags] = useState(false);
    const success = useRef(false);
    const typeCabinet = useRef();
    const [screenPermissions, setScreenPermissions] = useState({});

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, [success.current]);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [+params.idPermission, +params.idCabinet, +params.idDrawer];
        sendRequest(serviceList.getAllbox, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [success.current]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataCell = message.proc_data.rows[0].o_1;
            if (dataCell.at(-1).cell_lc.row && dataCell.at(-1).cell_lc.column) {
                let a = 0;
                const arr = [];
                for (let i = 0; i < dataCell.at(-1).cell_lc.row; i++) {
                    arr.push([]);
                    for (let j = 0; j < dataCell.at(-1).cell_lc.column; j++) {
                        arr[i].push(dataCell[a++]);
                    }
                }
                setTableData(arr);
            }
            typeCabinet.current = dataCell[0].cabinet_type;
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleLock = () => {
        if (!data.id) return toast.error(t('error.system_error'));
        if (lockRefFlags.current) {
            return;
        }
        setLockFlags(true);
        delFlags.current = true;
        const InVal = [+params.idPermission, data.id];
        sendRequest(serviceList.lockCabinet, InVal, lockResult, true, timeOutFunctLock, 40000);
    };

    const lockResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleLock(false);
            getData();
        }
    };

    const timeOutFunctLock = (reqInfo) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <Helmet>
                <title> {t('list_cells')} </title>
            </Helmet>

            <Container>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    {t('list_cells')}
                </Typography>{' '}
                <Breadcrumb
                    paths={[
                        {
                            label: t('quan_ly_tu'),
                            url: `/home/manager-cabinet/${params.idPermission}`,
                            navigate: false,
                        },
                        {
                            label: t('list_drawer'),
                            url: `/home/manager-cabinet/${params.idPermission}/drawer/${params.idCabinet}`,
                            navigate: false,
                        },
                        {
                            label: t('list_cells'),
                            url: '#',
                            navigate: false,
                        },
                    ]}
                />
                <CellModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    visible={visible}
                    dataUpdate={data}
                    fuctGet={getData}
                    setVisible={setVisible}
                    typeCabinet={typeCabinet.current}
                />
                <ConfirmLockModal visible={visibleLock} setVisible={setVisibleLock} handleSave={handleLock} />
                <Stack
                    direction="row"
                    flexWrap="wrap-reverse"
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ mb: 1 }}
                >
                    <Stack direction="row" spacing={1} flexShrink={0}></Stack>
                </Stack>
                <Loader loading={getFlags} />
                <CellList
                    products={tableData}
                    setData={setData}
                    idPermission={params.idPermission}
                    functEdit={() => {
                        isEdit.current = true;
                        setVisible(true);
                    }}
                    getData={getData}
                    typeCabinet={typeCabinet.current}
                    screenPermissions={screenPermissions}
                />
            </Container>
        </>
    );
}
